/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useSelector } from 'react-redux';
import { canEditItemForItem, getId } from '../../utils/item';
import { PicGlobal } from './pic.Global';
import { useWindowSize } from '../../hooks/useWindowSize';

export const PicSortable = props => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id });
  const { picId, itemId, zoom, masonry } = props;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const sidebar = useSelector(state => state.global.sidebar);
  const picZoom = useSelector(state => state.global.picZoom);
  const canEdit = canEditItemForItem(item, items);

  const [pic, setPic] = useState({});

  const windowSize = useWindowSize();

  useEffect(() => {
    if (item?.pics) {
      const picsObj = item.pics.find(picsObj => getId(picsObj) === picId);
      if (picsObj?.[picId]) {
        setPic(picsObj[picId]);
      }
    }
  }, [item?.pics]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={{
        ...style,
        height: masonry
          ? 'auto'
          : (windowSize.width - sidebar.size) / (zoom ? zoom * 2 : picZoom),
      }}
      className={`w-1/${zoom ?? picZoom}`}
    >
      <PicGlobal
        pic={pic}
        picId={picId}
        itemId={itemId}
        masonry={masonry}
        canEdit={canEdit}
      />
    </div>
  );
};
